import { MILLISECONDS_IN_DAY, MILLISECONDS_IN_HOUR, MILLISECONDS_IN_MINUTE } from './time-constants';

export const getDaysHoursMinsFromDateNumeric = (
  dateNumeric: number
): { days: number; hours: number; minutes: number } => {
  const days = Math.floor(dateNumeric / MILLISECONDS_IN_DAY);
  let remainingMilliseconds = dateNumeric % MILLISECONDS_IN_DAY;

  const hours = Math.floor(remainingMilliseconds / MILLISECONDS_IN_HOUR);
  remainingMilliseconds %= MILLISECONDS_IN_HOUR;

  const minutes = Math.floor(remainingMilliseconds / MILLISECONDS_IN_MINUTE);

  return {
    days: days,
    hours: hours,
    minutes: minutes,
  };
};
